import { Component, OnDestroy, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { AppState } from 'src/app/@store/app.reducers';
import * as compleWeb from '../../@store/complemento-web/complemento-web.actions';
import { ComplementoWebService } from 'src/app/services/complemento-web/complemento-web.service';
import { selectListaCatalogosSiniestros, selectObjetoDetalleSiniestroSiniestros } from '../../@store/complemento-web/complemento-web.selectors';
import { skipWhile, Subscription } from 'rxjs';
import { ConsultaSiniestroOutput, SiniestroDet } from 'src/app/models/complementos-web/complementos-web.model';
import { ProcesosComunesComplementoService } from 'src/app/services/complemento-web/procesos-comunes-complemento.service';
import { NgClass } from '@angular/common';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
    selector: 'app-detalle-siniestro-poliza',
    templateUrl: './detalle-siniestro-poliza.component.html',
    styleUrls: ['./detalle-siniestro-poliza.component.scss'],
    imports: [NgClass, MatTooltip]
})
export class DetalleSiniestroPolizaComponent implements OnInit, OnDestroy {

  public catalogosRedux: {
    consultaSexo: any[];
    consultaTipoPerdida: any[];
    consultaTipoEstimacion: any[];
    consultaSubtipoUbicaciones: any[];
    consultaEstatusLesionado: any[];
    consultaTipoGrua: any[];
    consultaEventoServicio: any[];
    consultaEstatusConcepto: any[];
    consultaEstatusAbogado: any[];
  };

  public detalleComplementoSiniestro: ConsultaSiniestroOutput;
  public siniestroCompleto: SiniestroDet;

  public screenSize: string = '';

  public listaObservables: Array<Subscription> = [];

  constructor(
    private procesosComplementoService : ProcesosComunesComplementoService, 
    private store: Store<AppState>,
    private complementoWebService: ComplementoWebService
  ) {
    this.onReduxChange();
    this.tamanoPantalla();
  }
  
  ngOnDestroy(): void {
    this.listaObservables.forEach(obs => obs.unsubscribe());
  }

  ngOnInit(): void {
    this.cargarCatalgosPrincipalesSiniestro();
  }

  onReduxChange() {
    const catalogosCW = this.store.select(selectListaCatalogosSiniestros).subscribe({
      next: (value) => {
        this.catalogosRedux = { ...value };
      },
    });
    const complementoWeb = this.store.select(selectObjetoDetalleSiniestroSiniestros).pipe(skipWhile(datos => datos == null)).subscribe({
      next: (value: ConsultaSiniestroOutput) => {
        this.detalleComplementoSiniestro = value;
        this.siniestroCompleto = value?.Siniestro?.[0];
        this.consultarCatalogoSubCausa(this.siniestroCompleto?.causa);
      },
    })
    this.listaObservables.push(catalogosCW);
    this.listaObservables.push(complementoWeb);
  }

  tamanoPantalla() {
    const subScreen = this.procesosComplementoService.screenSize$.subscribe(size => {
      this.screenSize = size;
    });
    this.listaObservables.push(subScreen);
  }

  consultarCatalogoSubCausa(idCausa) {
    return this.complementoWebService.consultaSubCausas({ causa: idCausa });
  }

  cargarCatalgosPrincipalesSiniestro() {
    this.store.dispatch(compleWeb.SolicitudCatalogosDetalleComplementoAction())
  }
}
